<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cMWNcr/tc-custom/cover.jpg?1685203788924?1696024483157" alt="This image is the cover for the book Joel and Amos, Tyndale Old Testament Commentaries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Joel and Amos, Tyndale Old Testament Commentaries
      </h1>
      <p class="bookDescription body article font2">
        <p>Joel's arresting imagery--blasting trumpet, darkened sun and marching hosts--has shaped the church's eschatological vision of a day of wrath. Amos's ringing indictments--callous oppression, heartless worship and self-seeking gain--have periodically awakened the conscience of God's people. Twenty-five-hundred years after they were first born, those prophetic words never fail to awaken and arrest. Viewed against the background of their culture and society, artistry and context, these visions and oracles take on even more vibrant colors and cleaner lines. This commentary is a valuable guide to the fascinating world and challenging word of these two prophets. Ever mindful of the wider context and composition of these ancient but living texts, David Hubbard shows how Joel and Amos addressed Israel's mind and heart. The original, unrevised text of this volume has been completely retypeset and printed in a larger, more attractive format with the new cover design for the series</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Allan Hubbard
      </h2>
      
      <p class="authorDescription body article">Hubbard (B.A., B.D., Th.M., Ph.D., D.D., L.H.D., Lit.D.) served as professor of Old Testament and president of Fuller Theological Seminary in Pasadena, California. He died in 1996.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bc687c38